"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var PropTypes = tslib_1.__importStar(require("prop-types"));

var apollo_client_1 = require("apollo-client");

var ts_invariant_1 = require("ts-invariant");

var shallowEqual_1 = tslib_1.__importDefault(require("./utils/shallowEqual"));

var parser_1 = require("./parser");

var component_utils_1 = require("./component-utils");

var initialState = {
  loading: false,
  called: false,
  error: undefined,
  data: undefined
};

var Mutation = function (_super) {
  tslib_1.__extends(Mutation, _super);

  function Mutation(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.hasMounted = false;

    _this.runMutation = function (options) {
      if (options === void 0) {
        options = {};
      }

      _this.onMutationStart();

      var mutationId = _this.generateNewMutationId();

      return _this.mutate(options).then(function (response) {
        _this.onMutationCompleted(response, mutationId);

        return response;
      })["catch"](function (e) {
        _this.onMutationError(e, mutationId);

        if (!_this.props.onError) throw e;
      });
    };

    _this.mutate = function (options) {
      var _a = _this.props,
          mutation = _a.mutation,
          variables = _a.variables,
          optimisticResponse = _a.optimisticResponse,
          update = _a.update,
          _b = _a.context,
          context = _b === void 0 ? {} : _b,
          _c = _a.awaitRefetchQueries,
          awaitRefetchQueries = _c === void 0 ? false : _c,
          fetchPolicy = _a.fetchPolicy;

      var mutateOptions = tslib_1.__assign({}, options);

      var refetchQueries = mutateOptions.refetchQueries || _this.props.refetchQueries;

      if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
        refetchQueries = refetchQueries.map(function (x) {
          if (typeof x === 'string' && _this.context.operations) return _this.context.operations.get(x) || x;
          return x;
        });
        delete mutateOptions.refetchQueries;
      }

      var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
      delete mutateOptions.variables;
      return _this.client.mutate(tslib_1.__assign({
        mutation: mutation,
        optimisticResponse: optimisticResponse,
        refetchQueries: refetchQueries,
        awaitRefetchQueries: awaitRefetchQueries,
        update: update,
        context: context,
        fetchPolicy: fetchPolicy,
        variables: mutateVariables
      }, mutateOptions));
    };

    _this.onMutationStart = function () {
      if (!_this.state.loading && !_this.props.ignoreResults) {
        _this.setState({
          loading: true,
          error: undefined,
          data: undefined,
          called: true
        });
      }
    };

    _this.onMutationCompleted = function (response, mutationId) {
      var _a = _this.props,
          onCompleted = _a.onCompleted,
          ignoreResults = _a.ignoreResults;
      var data = response.data,
          errors = response.errors;
      var error = errors && errors.length > 0 ? new apollo_client_1.ApolloError({
        graphQLErrors: errors
      }) : undefined;

      var callOncomplete = function callOncomplete() {
        return onCompleted ? onCompleted(data) : null;
      };

      if (_this.hasMounted && _this.isMostRecentMutation(mutationId) && !ignoreResults) {
        _this.setState({
          loading: false,
          data: data,
          error: error
        }, callOncomplete);
      } else {
        callOncomplete();
      }
    };

    _this.onMutationError = function (error, mutationId) {
      var onError = _this.props.onError;

      var callOnError = function callOnError() {
        return onError ? onError(error) : null;
      };

      if (_this.hasMounted && _this.isMostRecentMutation(mutationId)) {
        _this.setState({
          loading: false,
          error: error
        }, callOnError);
      } else {
        callOnError();
      }
    };

    _this.generateNewMutationId = function () {
      _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
      return _this.mostRecentMutationId;
    };

    _this.isMostRecentMutation = function (mutationId) {
      return _this.mostRecentMutationId === mutationId;
    };

    _this.verifyDocumentIsMutation = function (mutation) {
      var operation = parser_1.parser(mutation);
      ts_invariant_1.invariant(operation.type === parser_1.DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === parser_1.DocumentType.Query ? 'query' : 'subscription') + ".");
    };

    _this.client = component_utils_1.getClient(props, context);

    _this.verifyDocumentIsMutation(props.mutation);

    _this.mostRecentMutationId = 0;
    _this.state = initialState;
    return _this;
  }

  Mutation.prototype.componentDidMount = function () {
    this.hasMounted = true;
  };

  Mutation.prototype.componentWillUnmount = function () {
    this.hasMounted = false;
  };

  Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
    var nextClient = component_utils_1.getClient(nextProps, nextContext);

    if (shallowEqual_1["default"](this.props, nextProps) && this.client === nextClient) {
      return;
    }

    if (this.props.mutation !== nextProps.mutation) {
      this.verifyDocumentIsMutation(nextProps.mutation);
    }

    if (this.client !== nextClient) {
      this.client = nextClient;
      this.setState(initialState);
    }
  };

  Mutation.prototype.render = function () {
    var children = this.props.children;
    var _a = this.state,
        loading = _a.loading,
        data = _a.data,
        error = _a.error,
        called = _a.called;
    var result = {
      called: called,
      loading: loading,
      data: data,
      error: error,
      client: this.client
    };
    return children(this.runMutation, result);
  };

  Mutation.contextTypes = {
    client: PropTypes.object,
    operations: PropTypes.object
  };
  Mutation.propTypes = {
    mutation: PropTypes.object.isRequired,
    variables: PropTypes.object,
    optimisticResponse: PropTypes.object,
    refetchQueries: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])), PropTypes.func]),
    awaitRefetchQueries: PropTypes.bool,
    update: PropTypes.func,
    children: PropTypes.func.isRequired,
    onCompleted: PropTypes.func,
    onError: PropTypes.func,
    fetchPolicy: PropTypes.string
  };
  return Mutation;
}(React.Component);

exports["default"] = Mutation;